export default "__VITE_ASSET__CQAx6v2p__"